import { Injectable } from '@angular/core';
import { NameType } from '../../shared/models/models';
import { Synonym } from '../../shared/models/synonymer';
import { ApiService } from 'src/app/api/api.service';


@Injectable({
  providedIn: 'root',
})
export class SynonymerService {
  urls = {
    SMITTAMNE: 'namelists/synonymlists/SMITTAMNE',
    ANTIBIOTIKUM: 'namelists/synonymlists/ANTIBIOTIKUM',
    ANALYS: 'namelists/synonymlists/ANALYS',
    PROVMATERIAL: 'namelists/synonymlists/PROVMATERIAL',
    BESKRIVANDE: 'namelists/synonymlists/BESKRIVANDE',
    NEGATIVT: 'namelists/synonymlists/NEGATIVT'
  };

  constructor(private apiService: ApiService) {}

  getSynonymer(nameType: NameType): Promise<Synonym[]> {
    const url = this.urls[nameType];
    return this.apiService.get<Synonym[]>(url);
  }

  putSynonym(nameType: NameType, synonym: Synonym): Promise<Synonym> {
    const url = `${this.urls[nameType]}/${synonym.id}`;
    return this.apiService.put<Synonym>(url, synonym);
  }
}
